import { render, staticRenderFns } from "./compare-teams.vue?vue&type=template&id=3b48bc91&scoped=true"
import script from "./compare-teams.vue?vue&type=script&lang=js"
export * from "./compare-teams.vue?vue&type=script&lang=js"
import style0 from "./compare-teams.styl?vue&type=style&index=0&id=3b48bc91&prod&lang=stylus&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b48bc91",
  null
  
)

export default component.exports